import {AlertInfo} from 'presentation/components';
import React from 'react';

import {DESCRIPTIONS} from './constants';
import {StyledAlert} from './styles';
import {NetworkTypes} from 'presentation/modules/guide/health/ui/pages/HealthGuide/types';

export function NetworkAlert({type}: {type: NetworkTypes}) {
	const descripton = DESCRIPTIONS[type];
	if (!descripton) return null;

	return (
		<StyledAlert>
			<AlertInfo.Description>{descripton}</AlertInfo.Description>
		</StyledAlert>
	);
}
